import React from 'react'
import './user-info.scss'

const UserInfo = ({ user }) => {
    if (user.name.length > 20)
        user.name = `${user.name.slice(0, 17)}...`;
    return (
        <div className='user-info'>
            <div className="user-info__img">
                <img src={user.picture} alt="" />
            </div>
            <div className="user-info__name">
                <span>{user.name}</span>
            </div>
        </div>
    )
}

export default UserInfo
